
    <div role="tablist" class="panel-group"><ng-content></ng-content></div>
  